module.exports = __webpack_public_path__ + "static/US1_5P_modern_v2-f3a0304afa75b9a95c15c62f9d2f2d15.png";